import {
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { WizardSection } from '@app/models/project-setup.models';
import { GenericStore } from '@app/stores/generic.store';
import { WizardStore } from '@app/stores/project-setup/wizard.store';
import { CardComponent } from '@app/ui-components/card/card.component';
import { InfoLabelComponent } from '@app/ui-components/info-label/info-label.component';
import { ValidatedDatePickerComponent } from '@app/ui-components/validated-date-picker/validated-date-picker.component';
import { ValidatedDropdownComponent } from '@app/ui-components/validated-dropdown/validated-dropdown.component';
import { ValidatedNumberInputComponent } from '@app/ui-components/validated-number-input/validated-number-input.component';
import { TranslatePipe } from '@ngx-translate/core';
import { SectionBFormGroup } from '../+helpers/section-b-form.helper';

@Component({
  selector: 'app-section-b',
  imports: [
    TranslatePipe,
    ValidatedNumberInputComponent,
    ValidatedDatePickerComponent,
    ValidatedDropdownComponent,
    CardComponent,
    ReactiveFormsModule,
    InfoLabelComponent,
  ],
  templateUrl: './section-b.component.html',
  styleUrl: './section-b.component.scss',
})
export class SectionBComponent implements OnInit {
  genericStore = inject(GenericStore);
  wizardStore = inject(WizardStore);
  projectId = input.required<string>();
  protected formGroup = signal<FormGroup<SectionBFormGroup> | null>(null);
  protected translationKey = 'projectWizard.sectionBForm.';

  constructor(private destroyRef: DestroyRef) {}

  ngOnInit(): void {
    this.wizardStore
      .getSection(this.projectId(), WizardSection.B)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) =>
        this.formGroup.set(data as FormGroup<SectionBFormGroup>),
      );
  }
}
